<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb :breadCrumbIteams="breadCrumbIteams"></bread-crumb>
    </div>
    <!-- Summary -->
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>All Receivers List</h2>
          </div>
          <!-- Members Listing-->
          <div class="body pt-0">
            <!-- Filters/Buttons -->
            <div class="chart-top-action d-lg-flex justify-content-end py-3">
              <!-- SearchBox Filters -->
              <div class="mr-0 mr-md-3 action-top-search">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search Receivers"
                    aria-label="Search"
                    v-model="searchText"
                    aria-describedby="search-transactions"
                    v-on:keyup.enter="getBeneficiaryList"
                  />
                  <div class="input-group-append" @click="getBeneficiaryList()">
                    <span class="input-group-text" id="search-mail">
                      <i class="icon-magnifier"></i>
                    </span>
                  </div>
                </div>
              </div>
              <!-- Toggle Filter Button -->
              <div class="fliter-main mr-auto mt-3 mt-md-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="openFilters()"
                >
                  Filters
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <div class="d-flex mt-auto">
                <div class="fancy-checkbox">
                  <label>
                    <input
                      type="checkbox"
                      v-model="show_blacklisted"
                      @click="deleted_blacklistedList()"
                    />
                    <span class="font-weight-bold">Show Blacklisted</span>
                  </label>
                </div>
                <div class="fancy-checkbox">
                  <label>
                    <input
                      type="checkbox"
                      v-model="show_deleted"
                      @click="deleted_blacklistedList()"
                    />
                    <span class="font-weight-bold">Show Deleted</span>
                  </label>
                </div>
              </div>
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div
                  class="d-flex flex-column justify-content-between pt-3 pr-3 pl-3 middleware-list-wrapper"
                >
                  <div
                    v-for="(item, index) in advanceFilters"
                    :key="index"
                    class="d-flex middleware-list"
                  >
                    <div
                      class="form-group form-select single-multiselect m-0 column-1"
                    >
                      <span class="float-label w-100">
                        <label>Select Field</label>
                        <multiselect
                          placeholder=""
                          v-model="item.field"
                          :show-labels="false"
                          :options="filterField"
                          label="name"
                          :searchable="true"
                          :allowEmpty="false"
                          @select="fieldsUpdate"
                        ></multiselect>
                      </span>
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group m-0 column-2"
                      v-if="
                        item.field &&
                        (item.field.id == 'firstname' ||
                          item.field.id == 'lastname' ||
                          //item.field.id == 'middlename' ||
                          item.field.id == 'account_number' ||
                          item.field.id == 'momo_number')
                      "
                    >
                      <input
                        class="form-control"
                        type="text"
                        v-model="item.search"
                        :placeholder="'Enter ' + item.field.name"
                      />
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'country'"
                    >
                      <span class="float-label w-100">
                        <label>Select Country</label>
                        <v-select
                          :options="countryList"
                          multiple
                          v-model="item.country"
                          :get-option-label="(option) => option.name"
                        >
                          <template #option="option">
                            <div class="option__desc">
                              <span
                                :class="
                                  'flag-icon flag-icon-' +
                                  option.isoCode.toLowerCase() +
                                  ' fi-md fi-round '
                                "
                              ></span>
                              <span class="option__title">
                                {{ option.name }}
                              </span>
                            </div>
                          </template>
                        </v-select>
                      </span>
                    </div>
                    <!-- <div class="column-2" v-if="item.field && item.field.id == 'date'">
                                            <div class="form-group datepicker m-0 column-2-half">
                                                <b-input-group class="flex-nowrap">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text">From</span>
                                                        <span class="input-group-text" @click="$refs.birthdate1.showCalendar()"><i class="icon-calendar"></i></span>
                                                    </div>
                                                    <datepicker class="form-control" ref="birthdate1" v-model="item.date.from" :bootstrap-styling="false" placeholder=""  :typeable="true"></datepicker>
                                                </b-input-group>    
                                            </div>
                                            <div class="form-group datepicker m-0 column-2-half">
                                                <b-input-group class="flex-nowrap">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text">To</span>
                                                        <span class="input-group-text" @click="$refs.birthdate1.showCalendar()"><i class="icon-calendar"></i></span>
                                                    </div>
                                                    <datepicker class="form-control" ref="birthdate1" v-model="item.date.to" :bootstrap-styling="false" placeholder=""  :typeable="true"></datepicker>
                                                </b-input-group>    
                                            </div>
                                        </div> -->
                    <div v-if="advanceFilters.length > 1" class="column-3">
                      <b-button
                        class="fliter-btn btn-lg"
                        variant="outline-danger"
                        @click="removeFilter(index)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="text-left">
                    <b-button
                      class="fliter-btn w-auto"
                      variant="outline-primary"
                      @click="appendFilter"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      Add more filters
                    </b-button>
                  </div>
                </div>
                <div class="pb-3 pr-3 text-right">
                  <button
                    class="btn btn-primary w-auto"
                    @click="applyTestfilter"
                  >
                    Apply
                  </button>
                  <button
                    class="btn btn-outline-danger w-auto ml-3"
                    @click="clearTestfilter"
                  >
                    Cancel/Clear
                  </button>
                </div>
              </b-collapse>
            </div>
            <div
              class="filter-list-area d-flex flex-wrap align-items-center mb-1"
              v-if="displayFilters && displayFilters.length > 0"
            >
              <i
                class="fa fa-filter text-primary mr-1 mb-2"
                aria-hidden="true"
              ></i>
              <div
                class="mb-1"
                v-for="(item, index) in displayFilters"
                :key="index"
              >
                <label
                  class="font-14 line-height-18 mb-0 ml-2"
                  v-if="
                    index == 0 ||
                    item.filter_field != displayFilters[index - 1].filter_field
                  "
                >
                  {{ item.field_name + ":" }}
                </label>
                <!-- Only for country filter-->
                <template
                  v-if="
                    item.filter_field == 'country' ||
                    item.filter_field == 'sourcecountry'
                  "
                >
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="country in item.filter_value"
                    :key="country"
                  >
                    {{
                      countryList.filter(
                        (data) => data.countryid === country,
                      )[0]?.countryname
                    }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="removeCountry(country, item.filter_field, index)"
                    ></i>
                  </span>
                </template>
                <!-- Other filter -->
                <span class="badge badge-warning-solid" v-else>
                  {{ item.filter_value ? item.filter_value : "-" }}
                  <i
                    class="fa fa-close cursor-pointer ml-1"
                    @click="removeFilter(index)"
                  ></i>
                </span>
              </div>
              <span class="text-danger cursor-pointer" @click="clearTestfilter">
                Clear all
              </span>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- All Receivers List -->
            <b-table
              ref="beneficiaryTable"
              responsive
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="
                typeof items === 'array' || typeof items === 'object'
                  ? items
                  : []
              "
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @sort-changed="onSortChanged"
              striped
              show-empty
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(name)="data">
                <a
                  href="javascript:void(0);"
                  @click="linkedRemitterModel(data.item)"
                >
                  {{
                    formatFullName(
                      data.item.name,
                      data.item.mname,
                      data.item.lname,
                    ) || "-"
                  }}
                </a>
                <!-- <span>
                                    <i class="fa fa-ban text-danger ml-1" v-if="data.index == 2"></i>
                                    <span class="badge badge-danger ml-1" v-if="data.index == 3">Deleted</span>
                                </span> -->
              </template>
              <template #cell(country)="data">
                <div class="align-items-center d-flex">
                  <span
                    :class="`flag-icon flag-icon-${data.item.country?.isoCode} fi-lg fi-round`"
                  ></span>
                  <span
                    class="ml-2"
                    v-b-tooltip.hover
                    :title="data.item.country?.countryname"
                  >
                    {{ data.item.country?.isoCode.toUpperCase() }}
                  </span>
                </div>
              </template>
              <template #cell(sendername)="data">
                {{
                  data.value.fname
                    ? data.value.fname + " " + data.value.lname
                    : "-"
                }}
                <!-- <span>
                                    <i class="fa fa-ban text-danger ml-1" v-if="data.index == 2"></i>
                                    <span class="badge badge-danger ml-1" v-if="data.index == 3">Deleted</span>
                                </span> -->
              </template>
              <!-- <template #cell(optrc)="data">
                                {{ data.value }}
                                <i :class="data.value.class" style="font-size: 20px;"></i>
                            </template>
                            <template #cell(linked_sender)="data">
                                <span>{{data.value}} <i class="fa fa-copy" v-if="data.value != '-'" @click="copyText(data.value,'Payangel ID')"></i></span>
                            </template> -->
              <!-- <template #cell(action)="row">
                                <b-dropdown id="dropdown-1" text="Actions" right :variant="'outline-'+ (row.item._rowVariant ? 'danger' : 'primary')">
                                    <b-dropdown-item @click="showEdit(row)">Edit</b-dropdown-item>
                                    <b-dropdown-item v-if="row.index == 2" @click="removeFromBlacklist()">Remove From Blacklist</b-dropdown-item>
                                </b-dropdown>
                            </template> -->
              <template #cell(block_status)="data" v-if="$store.getters['authpermission/hasAnyPermission'](['receiver.status'])">
                <select
                  class="btn btn-filter badge badge-primary btn-lg"
                  v-model="data.value"
                >
                  <option value="">Select Option</option>
                  <option
                    v-for="(option, index) in blockStatuses"
                    :key="index"
                    :value="option"
                  >
                    {{ option.value }}
                  </option>
                </select>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { myFunction } from "@/common/common-helper.js";
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import { GET_ALLBENEFICIARY_LIST } from "../../../store/actions.type.js";
import "vue-select/dist/vue-select.css";
export default {
  name: "BeneficiaryListComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    "main-loader": LoaderComponent,
    Multiselect: () => import("vue-multiselect"),
    "v-select": () => import("vue-select"),
    // Datepicker: () => import('vuejs-datepicker'),
    // 'transactionstoprow-component': () => import('@/components/core/TransactionsTopRow.vue')
  },
  methods: {
    formatFullName(first, middle, last) {
      const normalize = (value) => {
        if (value === null || value === undefined) return "";
        const str = String(value).trim();
        if (!str) return "";
        const lower = str.toLowerCase();
        if (lower === "null" || lower === "undefined" || lower === "na")
          return "";
        return str;
      };
      const parts = [
        normalize(first),
        normalize(middle),
        normalize(last),
      ].filter(Boolean);
      return parts.join(" ").trim();
    },
    linkedRemitterModel(item) {
      // this.beneficiaryDetail = item;
      // setTimeout(() => {
      //     this.$bvModal.show('linked-remitter');
      // }, 100);
      let params = {
        beneficiary_id: this.$CryptoJS.AES.encrypt(
          item.beneficiaryid,
          "beneficiary_id",
        ).toString(),
        customer_id: this.$CryptoJS.AES.encrypt(
          item.customer_id,
          "customer_id",
        ).toString(),
        country_id: this.$CryptoJS.AES.encrypt(
          item.country_id,
          "country_id",
        ).toString(),
      };
      this.$router.push({
        name: "beneficiary-linked-remitters",
        params: params,
      });
    },
    removeFromBlacklist() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to remove Receiver from blacklist?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, remove it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              "Removed!",
              "Receiver has been Removed blacklist.",
              "success",
            );
          }
        });
    },
    // for openFilters
    openFilters() {
      this.cookieFilters();
      if (this.advanceFilters == 0) {
        this.advanceFilters = [
          {
            field: { id: "firstname", name: "First Name", $isDisabled: true },
            search: "",
            country: [],
            date: {
              from: "",
              to: "",
            },
            amount: {
              type: "",
              value: "",
            },
          },
        ];
      }
      this.isVisibleFilter = !this.isVisibleFilter;
    },
    deleted_blacklistedList() {
      setTimeout(() => {
        this.$cookies.set("receiver-show-deleted-blacklisted", {
          deleted: this.show_deleted,
          blacklisted: this.show_blacklisted,
        });
      }, 100);
    },
    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },

    showEdit(data) {
      console.log(data.item);
      // this.$router.push({name: 'beneficiary-edit', params: {beneficiary_id: this.$CryptoJS.AES.encrypt(data.item.beneficiaryid,'beneficiary_id').toString(),customer_id: this.$CryptoJS.AES.encrypt(data.item.customer_id,'customer_id').toString()}})
    },

    refreshBeneficiaryTable() {
      this.$refs.beneficiaryTable.refresh();
    },
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.items = [];
      if (this.sortBy != "") {
        this.getBeneficiaryList();
      }
    },
    async getBeneficiaryList() {
      if (this.searchText) {
        this.$router.replace({ path: this.$route.path, query: {} });
      }
      let page = "";
      let page_size = "";
      let sortby = "";
      let sort = false;
      if (this.currentPage != undefined) {
        page = this.currentPage;
      } else {
        page = 1;
      }
      if (this.perPage != undefined) {
        page_size = this.perPage;
      } else {
        page_size = 10;
      }
      if (this.sortBy == "") {
        sortby = "createdAt";
      } else if (this.sortBy == "name") {
        sortby = "firstname";
      } else if (this.sortBy == "sendername") {
        sortby = "customerfirstname";
      } else {
        sortby = this.sortBy;
      }
      if (this.sortDesc == true) {
        sort = "DESC";
      } else {
        sort = "ASC";
      }
      this.currentPageJump = page;
      const tempitems = [];
      let tempparam = `?sort=${sort}&sortby=${sortby}&size=${page_size}&page=${page}`;
      if (this.$route.query.customer_id) {
        tempparam =
          tempparam +
          `&customerid=${this.$CryptoJS.AES.decrypt(this.$route.query?.customer_id, "customer_id").toString(this.$CryptoJS.enc.Utf8)}`;
      } 
      //else {
        if (this.searchText) {
          tempparam = tempparam + `&search=${this.searchText.trimStart()}`;
        }
        if (this.show_deleted) {
          tempparam = tempparam + `&deleted=true`;
        }
        if (this.show_blacklisted) {
          tempparam = tempparam + `&blacklisted=true`;
        }
        if (this.displayFilters && this.displayFilters.length > 0) {
          this.displayFilters.map((item) => {
            if (item.filter_field == "country") {
              tempparam = tempparam + `&countries[]=${item.filter_value}`;
            } else {
              tempparam =
                tempparam + `&${item.filter_field}=${item.filter_value}`;
            }
          });
        }
      //}
      await this.$store
        .dispatch(GET_ALLBENEFICIARY_LIST, tempparam)
        .then((response) => {
          if (response.status == 200) {
            response.data.details.map((item) => {
              let customerLists = {
                customer_id: item.customerid,
                beneficiaryid: item.beneficiaryid,
                name: item.firstname != null ? item.firstname : "",
                // mname: item.middlename != null ? item.middlename : "",
                lname: item.lastname != null ? item.lastname : "",
                sendername: {
                  fname:
                    item.customerfirstname != null
                      ? item.customerfirstname
                      : "",
                  lname:
                    item.customerlastname != null ? item.customerlastname : "",
                },
                accountnumber: "-",
                mobilenumber: item.beneficiaryPhone
                  ? item.beneficiaryPhone
                  : "-",
                optrc: "-",
                country: item.beneficiaryCountryId
                  ? this.countryList.filter(
                      (data) => data.countryid === item.beneficiaryCountryId,
                    )[0]
                  : "-",
                country_id: item.beneficiaryCountryId
                  ? item.beneficiaryCountryId
                  : "-",
                momonumber: item.beneficiary_momo_number ? item.beneficiary_momo_number : "N/A",
                mobilenotify: item.is_mobile_notification == 1 ? item.mobile_notification : "N/A",
                emailnotify: item.is_email_notification == 1 ? item.email_notification : "N/A",
                action: "",
                linked_sender: "-",
              };
              tempitems.push(customerLists);
            });
            this.totalRows = response.data.query.total; //query.total;
          }
          this.items = tempitems;
        });
    },
    // append filters
    appendFilter() {
      this.advanceFilters.map((item) => {
        this.filterField.filter(
          (data) => data.id == item.field.id,
        )[0].$isDisabled = true;
      });
      if (this.filterField.filter((data) => data.$isDisabled == false)[0]) {
        this.advanceFilters.push({
          field: this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0],
          search: "",
          country: [],
          amount: {
            type: "",
            value: "",
          },
          date: {
            from: "",
            to: "",
          },
        });
        this.filterField.filter(
          (data) => data.$isDisabled == false,
        )[0].$isDisabled = true;
      }
    },
    // update fields of filters
    fieldsUpdate() {
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        this.filterField.filter(
          (data) => data.id == item.field.id,
        )[0].$isDisabled = true;
      });
    },
    // to remove filters
    removeFilter(index) {
      let fieldid = this.advanceFilters[index].field.id
        ? this.advanceFilters[index].field.id
        : this.displayFilters[index].filter_field;
      this.filterField.filter((data) => data.id == fieldid)[0].$isDisabled =
        false;
      this.advanceFilters.splice(index, 1);
      this.displayFilters.splice(index, 1);
      if (this.displayFilters.length == 0) {
        this.getBeneficiaryList();
      }
      this.$cookies.set("receiver-list-filter", this.displayFilters);
    },
    // remove country filters
    removeCountry(country, field, filterindex) {
      let temp = this.displayFilters.filter(
        (data) => data.filter_field == field,
      )[0].filter_value;
      let countries = [];
      let countriesobj = [];
      temp.map((item) => {
        if (item != country) {
          countries.push(item);
          countriesobj.push(
            this.countryList.filter((data) => data.countryid === item)[0],
          );
        }
      });
      if (countries.length > 0) {
        this.displayFilters.filter(
          (data) => data.filter_field == field,
        )[0].filter_value = countries;
      } else {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == field)[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.advanceFilters.map((item, index) => {
        if (item.field.id == field) {
          this.advanceFilters[index].country = countriesobj;
        }
      });
      this.$cookies.set("receiver-list-filter", this.displayFilters);
    },
    // apply filter
    applyTestfilter() {
      // if (this.$route.query.customer_id) {
      //   this.$router.replace({ path: this.$route.path, query: {} });
      // }
      let params = [];
      this.advanceFilters.map((item) => {
        let data = {
          filter_field: item.field.id,
          field_name: item.field.name,
        };
        if (
          item.field.id == "firstname" ||
          // item.field.id == "middlename" ||
          item.field.id == "lastname" ||
          item.field.id == "account_number" ||
          item.field.id == "momo_number"
        ) {
          data.filter_value = item.search;
        }
        if (item.field.id == "country") {
          //|| item.field.id == "sourcecountry"
          let countries = [];
          item.country.map((country) => {
            countries.push(country.countryid);
          });
          data.filter_value = countries;
        }
        params.push(data);
      });
      this.isVisibleFilter = false;
      this.$cookies.set("receiver-list-filter", params);
      this.displayFilters = this.$cookies.get("receiver-list-filter");
      console.log("params", params);
    },
    // clear filter
    clearTestfilter() {
      this.advanceFilters = [
        {
          field: { id: "firstname", name: "First Name", $isDisabled: true },
          search: "",
          country: [],
          date: {
            from: "",
            to: "",
          },
          amount: {
            type: "",
            value: "",
          },
        },
      ];
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.displayFilters = [];
      this.isVisibleFilter = false;
      this.$cookies.set("receiver-list-filter", this.displayFilters);
      this.getBeneficiaryList();
    },
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      myFunction.showInfo(`${type} Copied`, "success");
    },
    cookieFilters() {
      // this.displayFilters = this.$cookies.get('receiver-list-filter') != null ? this.$cookies.get('receiver-list-filter') : [];
      // if(this.$cookies.get('receiver-show-deleted-blacklisted')){
      //     this.show_deleted = this.$cookies.get('receiver-show-deleted-blacklisted').deleted;
      //     this.show_blacklisted = this.$cookies.get('receiver-show-deleted-blacklisted').blacklisted;
      // }
      let filters = [];
      if (this.displayFilters && this.displayFilters.length > 0) {
        this.displayFilters.map((item) => {
          this.filterField.filter(
            (data) => data.id == item.filter_field,
          )[0].$isDisabled = true;
          if (
            item.filter_field == "firstname" ||
            // item.filter_field == "middlename" ||
            item.filter_field == "lastname" ||
            item.filter_field == "account_number" ||
            item.filter_field == "momo_number"
          ) {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: item.filter_value,
              country: [],
              date: {
                from: "",
                to: "",
              },
              amount: {
                type: "",
                value: "",
              },
            });
          }

          if (
            item.filter_field == "country" ||
            item.filter_field == "sourcecountry"
          ) {
            let countries = [];
            item.filter_value.map((country) => {
              countries.push(
                this.countryList.filter(
                  (data) => data.countryid === country,
                )[0],
              );
            });
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: "",
              country: countries,
              date: {
                from: "",
                to: "",
              },
              amount: {
                type: "",
                value: "",
              },
            });
          }
        });
        this.advanceFilters = filters;
      }
    },
  },
  data() {
    return {
      items: [],
      beneficiaryDetail: null,
      fields: [
        {
          key: "country",
          label: "Country",
          sortable: false,
          thClass: "th_sortfix",
        },
        { key: "name", label: "Name", sortable: true, thClass: "th_sortfix" },
        // { key: 'sendername', label: 'Sender Name',sortable: true,thClass:'th_sortfix'},
        // { key: 'accountnumber', label: 'Account Number',sortable: false,thClass:'th_sortfix'},
        {
          key: "mobilenumber",
          label: "Mobile",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "momonumber",
          label: "MOMO Number",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "mobilenotify",
          label: "Mobile Notify",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "emailnotify",
          label: "Email Notify",
          sortable: false,
          thClass: "th_sortfix",
        },
        // { key: 'linked_sender', label: 'Linked Sender',sortable: false,thClass:'th_sortfix'},
        // { key: 'optrc', label: 'Opt for RC',sortable: false,thClass:'th_sortfix'},
        // { key: 'action', label: 'Action',thClass:'th_sortfix text-right pr-4',tdClass:'text-right'},
        {
          key: "block_status",
          label: "Block Status",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],
      blockStatuses: [
        { value: "Monitor" },
        { value: "Restricted" },
        { value: "Suspended" },
        { value: "Terminated" },
        { value: "Blacklisted" },
        { value: "Approved" },
      ],

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 50, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: true,

      isVisibleFilter: false,
      searchText: "",
      displayFilters: [],
      filterField: [
        { id: "firstname", name: "First Name", $isDisabled: false },
        // { id: "middlename", name: "Middle Name", $isDisabled: false },
        { id: "lastname", name: "Last Name", $isDisabled: false },
        { id: "country", name: "Country", $isDisabled: false },
        { id: "account_number", name: "Account Number", $isDisabled: false },
        { id: "momo_number", name: "Momo Number", $isDisabled: false },
      ],
      advanceFilters: [
        {
          field: { id: "firstname", name: "First Name", $isDisabled: false },
          search: "",
          country: [],
          date: {
            from: "",
            to: "",
          },
        },
      ],
      show_deleted: false,
      show_blacklisted: false,
      breadCrumbIteams: [
        {
          title: "Receivers",
          links: "",
        },
        {
          title: "Edit Receivers",
          links: "",
        },
      ],
    };
  },
  async mounted() {
    if (!this.$route.query.customer_id) {
      this.displayFilters =
        this.$cookies.get("receiver-list-filter") != null
          ? this.$cookies.get("receiver-list-filter")
          : [];
      if (this.$cookies.get("receiver-show-deleted-blacklisted")) {
        this.show_deleted = this.$cookies.get(
          "receiver-show-deleted-blacklisted",
        ).deleted;
        this.show_blacklisted = this.$cookies.get(
          "receiver-show-deleted-blacklisted",
        ).blacklisted;
      }
    }
    // await this.cookieFilters();
    if (this.displayFilters.length == 0) {
      this.getBeneficiaryList();
    }
  },
  watch: {
    displayFilters() {
      if (
        this.$cookies.get("receiver-list-filter") != null &&
        this.displayFilters.length > 0
      ) {
        this.getBeneficiaryList();
      }
    },
    currentPage: {
      handler: function () {
        this.getBeneficiaryList();
      },
    },
    perPage: {
      handler: function () {
        this.getBeneficiaryList();
      },
    },
    show_blacklisted: {
      handler: function () {
        this.getBeneficiaryList();
      },
    },
    show_deleted: {
      handler: function () {
        this.getBeneficiaryList();
      },
    },
  },
  computed: {
    ...mapGetters(["countryList", "isLoading"]),
  },
};
</script>
